import styled from 'styled-components';
import { colorCSS, getContainerWidth, mediaMinXl, shadow } from '../../../styles';
export const Detail = styled.div `
  display: flex;
  width: 100%;
  h3 {
    border-bottom: 1px solid ${colorCSS('N40')};
    color: ${colorCSS('N800')};
    font-family: 'Charlie Text';
    font-size: 1rem;
    padding-bottom: 1rem;
  }
`;
export const DetailInner = styled.div `
  transition: opacity 0.3s ease;
`;
export const DetailPrimary = styled.div `
  box-shadow: ${shadow['normal_inset']};
  font-size: 1rem;
  padding: 2rem 0 4.75rem 0;
  width: calc(
    ${getContainerWidth('lg', 8.5)} + ((100vw - ${getContainerWidth('lg')}) / 2)
  );
  ${mediaMinXl(`
    width: calc(
      ${getContainerWidth('xl', 8.5)} + ((100vw - ${getContainerWidth('xl')}) / 2)
    );
  `)}
  > div {
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 ${getContainerWidth('lg', 0.5)} 0 auto;
    padding: 0 2rem 0 1rem;
    width: ${getContainerWidth('lg', 8)};
    ${mediaMinXl(`
      margin: 0 ${getContainerWidth('xl', 0.5)} 0 auto;
      width: ${getContainerWidth('xl', 8)};
  `)}
  }
`;
export const DetailPrimaryLinks = styled.nav `
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
  gap: 1rem 0;
  > a {
    width: 33.33333%;
    > p:last-child {
      margin-bottom: 0;
    }
  }
`;
export const DetailSecondary = styled.div `
  background-color: ${colorCSS('P50', 0.4)};
  box-shadow: ${shadow['normal_inset']};
  padding: 2rem 0 4.75rem;
  width: calc(
    ${getContainerWidth('lg', 3.5)} + ((100vw - ${getContainerWidth('lg')}) / 2)
  );
  ${mediaMinXl(`
    width: calc(
      ${getContainerWidth('xl', 3.5)} + ((100vw - ${getContainerWidth('xl')}) / 2)
    );
  `)}
  > div {
    color: ${colorCSS('N400')};
    font-size: 0.75rem;
    margin: 0 auto 0 calc(${getContainerWidth('lg', 0.5)} - 1rem);
    width: ${getContainerWidth('lg', 3)};
    ${mediaMinXl(`
      margin: 0 auto 0 calc(${getContainerWidth('xl', 0.5)} - 1rem);
      width: ${getContainerWidth('xl', 3)};
    `)}
    p {
      margin-bottom: 0.5rem;
    }
  }
  h3 {
    border-bottom-color: ${colorCSS('P100')};
    margin-bottom: 1rem;
  }
`;
export const DetailSecondaryLinks = styled.div `
  display: flex;
  flex-direction: column;
  margin: -1rem;
  padding: 1.5rem 0;
  p:last-child {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=TabDetail.styles.js.map